import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class WindowRefService {
  private readonly browser: boolean;

  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    this.browser = isPlatformBrowser(platformId);
  }

  get nativeWindow(): (Window & typeof globalThis) | null {
    return this.browser ? window : null;
  }

  get grecaptcha(): any | null {
    return this.browser ? (window as any)?.grecaptcha ?? null : null;
  }
}
